"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.monitoring", [
    "nucont.shared",
    "nucont.accounting.company.showtime"
]);
require("./monitoring.routes");
